import React from 'react'

import DokumenPersiapan from 'app/KinerjaPage/pages/PelaksanaanV2/DokumenPersiapan'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { PageGuardPelaksanaan } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaan'
import { PageGuardPelaksanaanDate } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaanDate'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPelaksanaanEnabled =
      toggle?.['kinerja-pelaksanaan-enabled'] || false

    if (!isKinerjaEnabled || !isKinerjaPelaksanaanEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const DokumenPersiapanPage = () => {
  return (
    <PageGuardPelaksanaanDate>
      <PageGuardPelaksanaan pageState="DOCUMENT_PREPARATION">
        <DokumenPersiapan />
      </PageGuardPelaksanaan>
    </PageGuardPelaksanaanDate>
  )
}

DokumenPersiapanPage.Layout = KinerjaLayout

DokumenPersiapanPage.layoutOpts = {
  hasHeader: true,
}

export default DokumenPersiapanPage
